import { Reset } from "@/modules/auth/common/enum";
import { CARD_FORMAT } from "@/shared/common/constants";
import { formatCardNumber, isValidCard } from "@/shared/helpers";
import { useAppSelector, useFormatedInputCursor } from "@/shared/hooks";
import { FormField } from "@ab.uitools/ui-library/components/FormField";
import { Input } from "@ab.uitools/ui-library/components/Input";
import { useFormProps } from "@ab.uitools/ui-library/hooks/useFormProps";
import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

export const CardNumberFormFields = () => {
  const { t } = useTranslation();
  const { setValue, reset } = useFormProps();
  const resetFields = useAppSelector((state) => state.auth.reset);
  const inputRef = useRef<HTMLInputElement>(null);
  const { formatedInputOnChange } = useFormatedInputCursor(
    inputRef,
    (val) => formatCardNumber({ card: val })
  );

  useEffect(() => {
    if (resetFields.cardNumber) {
      reset?.({ [Reset.CardNumber]: "" });
      setValue(Reset.CardNumber, resetFields.cardNumber);
    }
  }, [resetFields]);

  return (
    <FormField
      name={Reset.CardNumber}
      className="mt-24"
      errorMessageIcon="infoFilled"
      As={(props) => {
        const { onChange, ...rest } = props;
        return (
          <Input
            {...rest}
            required
            ref={inputRef}
            className="mt-24"
            placeholder={CARD_FORMAT}
            label={t("auth.accountOrCardVerification.cardCharacters")}
            inputMode="numeric"
            onChange={formatedInputOnChange(onChange)}
            isAllowed={({ formattedValue }) => isValidCard(formattedValue)}
          />
        );
      }}
    />
  );
};
